import { Injectable } from "@angular/core";
import {
  CanActivate,
  CanActivateChild
} from "@angular/router";
import { AuthService } from "../services";

@Injectable({
  providedIn: "root"
})
export class AuthGuard implements CanActivate, CanActivateChild {

  constructor(private readonly authService: AuthService) {
  }

  canActivate(): boolean {
    return this.isAuthenticated();
  }

  canActivateChild(): boolean {
    return this.isAuthenticated();
  }

  private isAuthenticated(): boolean {
    return this.authService.authenticationCheck();
  }
}